import { FC, useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { UseFormSetValue } from 'react-hook-form'
import GET_AVAILABLE_TIME from 'graphql/queries/availableAppointmentTime'
import {
  AvailableAppointmentTime,
  AvailableAppointmentTimeQueryVariables,
  Listing,
} from 'graphql/types'
import DatePicker, { TDatePickerSelected } from 'components/DatePicker'
import Loader from 'components/Loader'
import Typography from 'components/Typography'
import {
  stepVisitEvent,
  setDayEvent,
  setHourEvent,
} from 'pages/imoveis/imovel/events'
import { TBuyerFormValues } from '../types'
import styles from './Schedule.module.scss'

export type TProps = {
  listing: Pick<Listing, 'uuid' | 'id'>
  setValue: UseFormSetValue<TBuyerFormValues>
  value?: TDatePickerSelected | null
}

const Schedule: FC<TProps> = ({ setValue, value, listing }) => {
  const { data, loading } = useQuery<
    { availableAppointmentTime: Array<AvailableAppointmentTime> },
    AvailableAppointmentTimeQueryVariables
  >(GET_AVAILABLE_TIME, {
    ssr: true,
    variables: {
      listingUuid: listing?.uuid || '',
    },
  })

  useEffect(() => {
    stepVisitEvent({ step: 'date' })
  }, [])

  return (
    <div
      className={styles.ecVisitModalSchedule}
      data-testid="ecModalVisitSchedule"
    >
      <div className={styles.ecScheduleTip}>
        <Typography variant="TitleSmall" bold>
          Quando você quer visitar o imóvel?
        </Typography>
        <Typography variant="ParagraphSmall">
          A localização exata do imóvel é informada na confirmação da visita com
          nossos corretores
        </Typography>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <DatePicker
          items={data?.availableAppointmentTime || []}
          defaultValue={value || {}}
          onChange={(result) =>
            result.dateString &&
            setValue('appointment', result, {
              shouldValidate: true,
            })
          }
          onDaySelect={(date, weekday) => {
            setDayEvent({ date, weekday })
          }}
          onHourSelect={(hour) => {
            setHourEvent({ hour })
          }}
          slidesPerPage={3}
          slidesGap={10}
        />
      )}
    </div>
  )
}

export default Schedule
